module.exports = __webpack_public_path__ + "static/media/SofiaProUltraLight.4bdc72d8.otf";